module.exports = __webpack_public_path__ + "static/media/about_image_01.43fa61fa.jpg";